import * as Illustration from "@npco/zeller-design-system/illustration";

import { ListSteps } from "../../shared/list-steps";
import { PromptBig } from "../../shared/prompt-big";
import { Layout } from "./layout";

export namespace AuthenticationRefreshFailure {
	export type Props = {
		onClose: () => void;
		onLogin: () => void;
	};
}

export function AuthenticationRefreshFailure(
	props: AuthenticationRefreshFailure.Props,
) {
	return (
		<Layout
			logo
			onClose={props.onClose}
			actions={[
				{
					label: "Login",
					onClick: props.onLogin,
				},
			]}
			actionsStyle="full-width"
		>
			<PromptBig
				image={<Illustration.LockedLockAndKey />}
				title="Zeller Authentication Failed"
				message={
					<>
						Something went wrong when trying to authenticate your application:
						<ListSteps
							items={[
								"Log in with your Zeller credentials to continue.",
								"If the problem persists, please contact Zeller for further assistance.",
							]}
						/>
					</>
				}
			/>
		</Layout>
	);
}
